<template>
<div class="representative-flow searching-representative">
        <div class="search-heading">
          <i class="pi pi-user" aria-hidden="true"></i>
          <h4>{{ isStandalone ? 'Verifica il nuovo rappresentante' : 'Cerca il nuovo rappresentante' }}</h4>
          <p>Inserisci il codice fiscale o la partita IVA. La ricerca parte automaticamente al completamento.</p>
        </div>
        <div class="representative-radio-group mb-3">
          <div class="representative-radio">
            <RadioButton inputId="cambio-rapp-fisica" v-model="kind" value="cf" :disabled="busy" />
            <label for="cambio-rapp-fisica" class="m-0">Persona fisica</label>
          </div>
          <div class="representative-radio">
            <RadioButton inputId="cambio-rapp-giuridica" v-model="kind" value="piva" :disabled="busy" />
            <label for="cambio-rapp-giuridica" class="m-0">Persona giuridica</label>
          </div>
        </div>
        <div class="representative-search mx-auto mt-4 mb-3">
          <label for="cambio-rapp-cf">{{ kind === 'cf' ? 'Codice fiscale' : 'Partita IVA' }} <span class="p-error">(obbligatorio)</span></label>
          <InputMask v-if="kind === 'cf'" :key="`cf-${searchInputKey}`" id="cambio-rapp-cf" v-model="cf" mask="aaaaaa99a99a***a" class="identifier-input uppercase-identifier" :disabled="busy" @keydown="clearDuplicateIdentifier" @paste="clearDuplicateIdentifier" @complete="onIdentifierComplete" />
          <InputMask v-else :key="`piva-${searchInputKey}`" id="cambio-rapp-cf" v-model="cf" mask="99999999999" inputmode="numeric" class="identifier-input" :disabled="busy" @keydown="clearDuplicateIdentifier" @paste="clearDuplicateIdentifier" @complete="onIdentifierComplete" />
          <InlineMessage v-if="duplicateIdentifier" severity="error" class="duplicate-representative-message" role="alert">{{ duplicateIdentifier }} — Esiste già un rappresentante con {{ kind === 'cf' ? 'questo codice fiscale' : 'questa partita IVA' }}.</InlineMessage>
          <small v-if="busy" class="block mt-2" role="status">Ricerca del rappresentante in corso...</small>
        </div>
      </div>
</template>

<script>
import InputMask from 'primevue/inputmask'
import RadioButton from 'primevue/radiobutton'
import InlineMessage from 'primevue/inlinemessage'

export default {
  components: { InputMask, RadioButton, InlineMessage },
  inject: ['representativeDialog'],
  computed: {
    isStandalone() { return this.representativeDialog.isStandalone },
    busy() { return this.representativeDialog.busy },
    duplicateIdentifier() { return this.representativeDialog.duplicateIdentifier },
    searchInputKey() { return this.representativeDialog.searchInputKey },
    kind: { get() { return this.representativeDialog.kind }, set(value) { this.representativeDialog.kind = value } },
    cf: { get() { return this.representativeDialog.cf }, set(value) { this.representativeDialog.cf = value; if (value) this.representativeDialog.duplicateIdentifier = '' } },
  },
  methods: {
    clearDuplicateIdentifier() { this.representativeDialog.duplicateIdentifier = '' },
    onIdentifierComplete(...args) { return this.representativeDialog.onIdentifierComplete(...args) },
  }
}
</script>
